import { useMsal } from "@azure/msal-react";
import UnAuthenticatedRoutes from "./UnauthenticatedRoutes";
import AuthenticatedRoutes from "./AuthenticatedRoutes";
import React, { useSyncExternalStore } from "react";
import { BrowserRouter } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { Loading } from "../ui-components/Loading";
import { ChatProvider } from "../contexts/ChatContext";
import { GoogleMapsProvider } from "../contexts/GoogleMapsProvider";
import { getSessionVersion, isSigningOut, subscribeToSession } from "../auth/session";
import { AuthStatusScreen } from "../pages/auth/components/AuthShell";

function Routes() {
  //get current user
  const user = useMsal();

  // Native sign-in raises no MSAL login events, so also re-render when the session changes.
  useSyncExternalStore(subscribeToSession, getSessionVersion);
  const accountCount = user.instance.getAllAccounts().length;

  const expired = user.instance.getActiveAccount()?.idTokenClaims?.exp;
  const hasExpired = expired ? new Date(expired * 1000) < new Date() : false;

  var userLoading =
    user.inProgress === InteractionStatus.HandleRedirect ||
    user.inProgress === InteractionStatus.AcquireToken ||
    user.inProgress === InteractionStatus.Startup;

  if (userLoading) return <Loading />;

  // Sign-out is under way and the browser is about to navigate. Rendering the signed-out routes
  // here would start a new sign-in against Entra's still-valid session cookie.
  if (isSigningOut()) return <AuthStatusScreen message="Signing you out…" />;

  const isLoggedOutPage = window.location.pathname === "/logged-out";
  if (
    (accountCount === 0 ||
      hasExpired ||
      !user.instance.getActiveAccount()) &&
    !isLoggedOutPage
  ) {
    console.log("User is not logged in");
    return (
      <BrowserRouter>
        <UnAuthenticatedRoutes />
      </BrowserRouter>
    );
  }
  if (isLoggedOutPage && accountCount === 0) {
    return (
      <BrowserRouter>
        <UnAuthenticatedRoutes />
      </BrowserRouter>
    );
  }
  return (
    <BrowserRouter>
      <GoogleMapsProvider>
        <ChatProvider>
          <AuthenticatedRoutes />
        </ChatProvider>
      </GoogleMapsProvider>
    </BrowserRouter>
  );
}

export default Routes;
